if (!customElements.get('product-recommendations')) {
	customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.recommendation-list')) {
              this.classList.add('product-recommendations--loaded');
              enablePetVibessRecommendationDrag(this);
            } else {
              this.classList.add('hidden');
            }
          })
          .catch(e => {
            console.error(e);
            this.classList.add('hidden');
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  });
}

function enablePetVibessRecommendationDrag(root) {
  const track = root.querySelector('.recommendation-list.slider');
  if (!track || track.dataset.petvibessDrag === 'true') return;

  track.dataset.petvibessDrag = 'true';
  let pointerStartX = 0;
  let scrollStart = 0;
  let dragging = false;
  let moved = false;

  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'touch' || event.button !== 0) return;
    pointerStartX = event.clientX;
    scrollStart = track.scrollLeft;
    moved = false;
    track.setPointerCapture(event.pointerId);
  });

  track.addEventListener('pointermove', (event) => {
    if (!track.hasPointerCapture(event.pointerId)) return;
    const distance = event.clientX - pointerStartX;
    if (Math.abs(distance) > 4) {
      dragging = true;
      moved = true;
      track.classList.add('is-dragging');
      track.scrollLeft = scrollStart - distance;
    }
  });

  const endDrag = (event) => {
    if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    dragging = false;
    track.classList.remove('is-dragging');
  };

  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);
  track.addEventListener('click', (event) => {
    if (moved || dragging) {
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }
  }, true);
}
